export default "__VITE_ASSET__CbqxX4HB__"